import { render, staticRenderFns } from "./P1L1.vue?vue&type=template&id=2f604a52&"
import script from "./P1L1.vue?vue&type=script&lang=js&"
export * from "./P1L1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports